<template>
  <form>
    <v-app>
      <v-container fluid grid-list-lg>
        <v-card>
          <v-toolbar>
            <v-icon>perm_identity</v-icon>
            <v-toolbar-title class="font-weight-light"
              >Legajo de Persona Física</v-toolbar-title
            >
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-container>
            <v-layout wrap>
              <v-flex lg12>
                <div class="subheading">Resumen</div>
                <v-chip
                  v-if="model && model.status && model.status.baja"
                  class="ma-2"
                  :color="
                    model.status.motivoBaja.includes('Lista negra')
                      ? 'black'
                      : 'red'
                  "
                  text-color="white"
                  label
                >
                  <span>
                    {{
                      model.status.motivoBaja.includes('Lista negra')
                        ? model.status.motivoBaja.toUpperCase()
                        : 'DE BAJA'
                    }}
                  </span>
                  <v-icon right>thumb_down</v-icon>
                </v-chip>
              </v-flex>

              <v-flex lg3>
                <v-card dark color="purple">
                  <v-card-text>
                    <div class="caption">
                      {{ model.apellido + ', ' + model.nombre }}
                    </div>
                    <div class="caption">
                      DNI {{ documentoFormateado }} / {{ edad }} Años
                    </div>
                    <div class="caption">&nbsp;</div>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex lg3>
                <v-card dark color="green darken-3">
                  <v-card-text>
                    <div class="caption">Email: {{ email }}</div>
                    <div class="caption">Celular: {{ numeroCelular }}</div>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <div
                          class="caption"
                          @click="gotoDatosContacto"
                          v-on="on"
                        >
                          + datos
                        </div>
                      </template>
                      <p>Ver Datos de Contacto</p>
                    </v-tooltip>
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex lg3>
                <v-card dark color="blue ligthten-3">
                  <v-card-text>
                    <div class="caption">{{ trabajaEn }}</div>
                    <div class="caption">{{ cuitLaboral }}</div>
                    <div class="caption">
                      {{ ingresosLaboral }} / {{ antiguedadLaboral }}
                    </div>
                    <div class="caption">{{ ingresoLiquido }}</div>
                    <div class="caption">{{ ingresoConsiderado }}</div>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>

          <v-card-text>
            <v-container fluid grid-list-lg>
              <v-layout>
                <v-flex lg10 xl8>
                  <v-tabs v-model="active" color="orange" slider-color="green">
                    <v-tab key="particulares" ripple>
                      Datos Particulares
                    </v-tab>
                    <v-tab key="contacto" ripple> Datos de Contacto </v-tab>

                    <v-tab key="laborales" ripple> Datos Laborales </v-tab>

                    <v-tab key="gestion" ripple>
                      Cuentas Bancarias y Gestión
                    </v-tab>

                    <v-tab key="tarjetas" ripple> Datos Tarjeta </v-tab>

                    <v-tab
                      key="afiliaciones"
                      ripple
                      v-if="model.id != '00000000-0000-0000-0000-000000000000'"
                    >
                      Afiliaciones
                    </v-tab>

                    <v-tab-item key="particulares">
                      <v-card flat>
                        <datos-particulares :value="model"></datos-particulares>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="contacto">
                      <v-card flat>
                        <datos-contacto
                          :value="model.datosContacto"
                        ></datos-contacto>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="laborales">
                      <v-card flat>
                        <app-manejo-empleos :value="model"></app-manejo-empleos>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="gestion">
                      <v-card flat>
                        <datos-gestion :value="model"></datos-gestion>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="tarjetas">
                      <v-card flat>
                        <app-datos-tarjeta-tokenizada
                          :value="model"
                        ></app-datos-tarjeta-tokenizada>
                      </v-card>
                    </v-tab-item>

                    <v-tab-item key="afiliaciones">
                      <v-card flat>
                        <datos-afiliaciones
                          :value="model.afiliaciones"
                          :personaId="personaId"
                          v-on:update-productos-contratados="
                            updateProductosContratados
                          "
                        >
                        </datos-afiliaciones>
                      </v-card>
                    </v-tab-item>
                  </v-tabs>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions bottom>
            <v-speed-dial direction="right">
              <template v-slot:activator>
                <v-btn color="orange" text small v-show="editMode">
                  <v-icon color="orange">touch_app</v-icon>
                  Mas Acciones
                </v-btn>
              </template>
              <!-- <v-btn small text color="green" v-show="editMode" @click="verCreditos">
              Ver Créditos
            </v-btn> -->

              <v-btn
                v-if="model && model.status && model.status.baja"
                small
                text
                color="green"
                v-show="editMode"
                @click="rehabilitarCliente"
                >Rehabilitar</v-btn
              >
              <v-btn
                v-else
                small
                text
                color="green"
                v-show="editMode && checkCanAccess('ap-mod-lista-negra')"
                @click="darDeBaja"
                >Dar de Baja</v-btn
              >
              <!-- <span v-if="model.status.baja">Re-Habilitar</span>
                <span v-else>Dar de Baja</span> -->
              <v-btn
                small
                text
                color="black"
                v-show="editMode"
                v-if="
                  checkCanAccess('ap-mod-lista-negra') &&
                  model.status &&
                  (!model.status.baja ||
                    (model.status.baja &&
                      !model.status.motivoBaja.includes('Lista negra')))
                "
                @click="agregarAListaNegra"
              >
                Agregar a Lista Negra
              </v-btn>
            </v-speed-dial>

            <v-spacer></v-spacer>
            <v-btn
              color="success"
              :disabled="!editMode || loading"
              @click="saveItem"
              :loading="saving"
              ><v-icon>save</v-icon>Guardar</v-btn
            >
          </v-card-actions>
        </v-card>

        <app-loading :loading="loading || saving"></app-loading>
      </v-container>
    </v-app>
  </form>
</template>

<script>
import DatosParticulares from './particulares';
import DatosLaborales from './laborales';
import DatosContacto from './contacto';
import DatosGestion from './gestion';
import DatosTarjetaTokenizada from './gestion';
import Afiliaciones from './afiliaciones';

import Vue from 'vue';
import { http } from '@/axios';

import { mapGetters, mapMutations } from 'vuex';

export default {
  props: ['personaId'],
  data() {
    return {
      active: null,
      loading: false,
      saving: false,
      editMode: true,
      showManejoCuotaSocial: false,
      model: {
        domicilios: [],
        empleos: [],
        status: {},
        tarjetasTokenizadas: [],
        cuentasBanco: [],
      },
    };
  },
  components: {
    'datos-particulares': DatosParticulares,
    'datos-laborales': DatosLaborales,
    'datos-contacto': DatosContacto,
    'datos-gestion': DatosGestion,
    'datos-tarjeta-tokenizada': DatosTarjetaTokenizada,
    'datos-afiliaciones': Afiliaciones,
  },
  async created() {
    if (this.personaId) this.loadPersona(this.personaId);
  },
  computed: {
    ...mapGetters(['checkCanAccess']),
    edad: function () {
      var dob = this.$moment(this.model.fechaNacimiento);

      if (dob.isValid) {
        var ageDifMs = Date.now() - dob.toDate().getTime();
        var ageDate = new Date(ageDifMs); // miliseconds from epoch
        return Math.abs(ageDate.getUTCFullYear() - 1970);
      }
      return '-';
    },
    documentoFormateado: function () {
      if (this.model.documento) {
        var doc = this.model.documento.replace(/\./g, '').substring(0, 8);

        if (doc.length < 8) doc = '0'.repeat(8 - doc.length) + doc;

        doc =
          doc.substring(0, 2) +
          '.' +
          doc.substring(2, 5) +
          '.' +
          doc.substring(5, 8);
      }
      return doc;
    },
    numeroCelular: function () {
      if (this.model.datosContacto && this.model.datosContacto.telefonos) {
        for (
          let index = 0;
          index < this.model.datosContacto.telefonos.length;
          index++
        ) {
          const item = this.model.datosContacto.telefonos[index];
          if (item.esCelular) {
            return item.numero;
          }
        }
        return '(no cargado)';
      }
      return '';
    },
    email: function () {
      if (this.model.datosContacto) {
        if (this.model.datosContacto.email != '')
          return this.model.datosContacto.email;
        else return '(no cargado)';
      }
      return '';
    },
    trabajaEn: function () {
      if (this.model.empleo) {
        return 'Trabaja en ' + this.model.empleo.empleador;
      }
      return '';
    },
    cuitLaboral: function () {
      if (this.model.empleo) {
        return 'Cuit: ' + this.model.empleo.cui;
      }
      return '';
    },
    ingresosLaboral: function () {
      if (this.model.empleo) {
        return 'Ingresos x $ ' + this.model.empleo.ingresoNeto;
      }
      return '';
    },
    ingresoConsiderado: function () {
      if (this.model.empleo) {
        if (this.model.empleo.ingresoConsiderado != 0)
          return (
            'Ingreso Considerado $ ' + this.model.empleo.ingresoConsiderado
          );
      }
      return '';
    },
    ingresoLiquido: function () {
      if (this.model.empleo) {
        if (this.model.empleo.ingresoLiquido != 0)
          return 'Ingreso Base $ ' + this.model.empleo.ingresoLiquido;
      }
      return '';
    },
    antiguedadLaboral: function () {
      if (this.model.empleo) {
        var ing = this.$moment(this.model.empleo.fechaIngreso);
        if (ing.isValid) {
          var ageDifMs = Date.now() - ing.toDate().getTime();
          var ageDate = new Date(ageDifMs); // miliseconds from epoch
          return 'Antig: ' + Math.abs(ageDate.getUTCFullYear() - 1970) + ' A';
        }
        return 'Antig: -';
      }
      return '';
    },
  },
  watch: {
    personaId: function () {
      console.log(this.personaId);

      if (this.personaId) {
        this.clear();
        this.loadPersona(this.personaId);
      }
    },
  },
  methods: {
    ...mapMutations([
      'alertClear',
      'alertSuccess',
      'alertWarning',
      'alertError',
      'setActiveTask',
    ]),
    next() {
      const active = parseInt(this.active);
      this.active = active < 2 ? active + 1 : 0;
    },
    async gotoDatosContacto() {
      this.active = 1;
    },
    async loadPersona(personaId) {
      this.loading = true;
      try {
        var result = await http.get('personas/' + personaId);

        this.model = result;

        // trato las fechas
        var dob = this.$moment(this.model.fechaNacimiento).format('YYYY-MM-DD'); // Todo: ver qué pasa cuando graba
        this.model.fechaNacimiento = dob;

        if (this.model.empleo != null) {
          var fi = this.$moment(this.model.empleo.fechaIngreso).format(
            'YYYY-MM-DD'
          );
          this.model.empleo.fechaIngreso = fi;
        }

        Vue.$log.debug(this.model);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.loading = false;
    },
    async saveItem() {
      await this.$validator.validateAll();

      if (this.errors.items.length > 0) {
        Vue.$log.debug('validation:');
        Vue.$log.debug(this.errors);
        return;
      }

      const isUpdate = this.model.id !== '00000000-0000-0000-0000-000000000000';

      try {
        this.saving = true;
        var result;

        if (isUpdate) {
          result = await http.put(
            'personas',
            JSON.stringify({ persona: this.model })
          );
        } else {
          result = await http.post(
            'personas',
            JSON.stringify({ persona: this.model })
          );
        }
        this.alertSuccess('Los cambios han sido guardados.');

        // recargo los datos
        this.loadPersona(result.entity.id);
      } catch (error) {
        // Error
        this.alertError(error);
      }
      this.saving = false;
    },
    clear() {
      this.model = { domicilios: [], empleos: [] };
    },
    async agregarAListaNegra() {
      let res = await this.$dialog.prompt({
        text: '',
        title:
          'El cliente va a ser agregado a la lista negra. Ingrese el motivo o presione cancelar.',
      });

      if (res != false) {
        this.model.status.baja = true;
        this.model.status.motivoBaja = 'Lista negra por ' + res;
        this.model.status.fechaBaja = new Date();

        this.saveItem();
      }
    },
    async darDeBaja() {
      let res = await this.$dialog.prompt({
        text: '',
        title:
          'El cliente va a ser dado de baja. Ingrese el motivo o presione cancelar.',
      });

      if (res != false) {
        this.model.status.baja = true;
        this.model.status.motivoBaja = res;
        this.model.status.fechaBaja = new Date();

        this.saveItem();
      }
    },
    async rehabilitarCliente() {
      let res = await this.$dialog.confirm({
        title: 'Se quitará la marca de Lista Negra del Cliente. Está seguro?',
      });

      if (res != false) {
        this.model.status.baja = false;
        this.model.status.motivoBaja = null;
        this.model.status.fechaBaja = null;

        this.saveItem();
      }
    },
    async verCreditos() {
      this.selectedPersonaId = this.model.id;
      //this.showListaCreditos = true;

      var params = {
        width: 900,
        visible: true,
        personaId: this.model.id,
      };

      this.setActiveTask({ task: 'app-lista-creditos', props: params });
    },
    updateProductosContratados: function (contraNuevos) {
      this.model.afiliaciones = contraNuevos;
    },
  },
};
</script>
